import {
  getGeoLocation
} from "./chunk-H3BAINZ7.mjs";
import {
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/geo/location.ts
import { useQuery } from "@tanstack/react-query";
var useGeoLocation = (options) => {
  return useQuery(__spreadValues({
    queryKey: ["getGeoLocation"],
    queryFn: () => getGeoLocation()
  }, options));
};

export {
  useGeoLocation
};
//# sourceMappingURL=chunk-ER5QWX2V.mjs.map